import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Navigation from '../components/Navigation';
import { deposit } from '../actions/accountActions';

const DepositPage: React.FC = () => {
  const accountsList = useSelector((state: appState) => state.accountsList);
  const { accounts, dsuccess, error } = accountsList;

  const [amount, setAmount] = useState('1.00');
  const [number, setNumber] = useState(accounts[0].number);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userLogin = useSelector((state: appState) => state.userLogin);
  const { userData } = userLogin;

  useEffect(() => {
    if (!userData) {
      navigate('/');
    }
  }, [navigate, userData]);

  const lastFour = (str: string) => {
    return str.slice(-4);
  };

  const cancelHandler = () => {
    navigate('/account');
  };

  const submitHandler = (e: React.FormEvent) => {
    e.preventDefault();

    const numAmount = parseFloat(amount).toFixed(2);

    const depositAmount = parseFloat(numAmount);

    dispatch(deposit(number, depositAmount));

    setTimeout(() => {
      navigate('/account');
    }, 2000);
  };

  return (
    <div className='account-page'>
      <Navigation />
      <form className='transaction-form' onSubmit={submitHandler}>
        <label htmlFor='deposit-amount'>Deposit Amount ($):</label>
        <input
          type='number'
          name='deposit-amount'
          id='deposit-amount'
          className='transaction-input'
          min='0.01'
          step='0.01'
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
        <p>Select account to make a deposit to: </p>
        <select
          name='deposit-select'
          id='deposit-select'
          className='transaction-select'
          onChange={(e) => setNumber(e.target.value)}
        >
          {accounts.map((account) => (
            <option key={account.id} value={account.number}>
              {account.type} {lastFour(account.number)}
            </option>
          ))}
        </select>
        <div className='transaction-buttons'>
          <button className='cancel-btn' onClick={cancelHandler}>
            Cancel
          </button>
          <button type='submit' className='submit-btn deposit-btn'>
            Deposit
          </button>
        </div>
        {dsuccess && (
          <p className='d-success'>Your deposit has been made successfully!</p>
        )}
        {error && <p className='t-error'>{error}</p>}
      </form>
    </div>
  );
};

export default DepositPage;
